import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { AgentSaleMissingInformationTodoFooterProps } from "models/propTypes/agentSalesPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AgentSaleMissingInformationTodoFooter: React.FC<AgentSaleMissingInformationTodoFooterProps> = (props) => {
  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Snooze),
          onClick: props.onSnoozeClicked,
          type: StyleEnums.DisplayType.Info,
        },
      ]}
      disableSuccessMessages
    />
  );
};

export default AgentSaleMissingInformationTodoFooter;
